<template>
  <v-container fluid style="overflow: hidden !important;" class="CSChatThai">
    <v-layout row wrap v-if="status_login === 'T'" class="hidden-sm-and-down">
      <v-flex sm12 md12 lg12 xl12 v-if="progress">
        <v-layout row wrap justify-center align-center class="height-100vh">
          <v-progress-circular :size="100" :indeterminate="progress" color="primary"></v-progress-circular>
        </v-layout>
      </v-flex>
      <v-flex sm12 md12 lg12 xl12 v-else>
        <v-navigation-drawer
          app
          v-model="drawer"
          right
          :mini-variant.sync="mini"
          style="margin-top: 60px !important; background-color: #1b232d !important;"
        >
          <v-toolbar flat class="transparent">
            <v-list class="pa-0">
              <v-list-tile avatar>
                <v-list-tile-avatar>
                  <v-btn @click.stop="mini = !mini" fab dark small class="btn-nav">
                    <v-icon color="black">{{mini ? 'fas fa-chevron-left' : 'fas fa-chevron-right'}}</v-icon>
                  </v-btn>
                </v-list-tile-avatar>
                <v-spacer></v-spacer>
              </v-list-tile>
            </v-list>
          </v-toolbar>
          <Rightside v-if="mini" style="display: none !important;"></Rightside>
          <Rightside v-else></Rightside>
        </v-navigation-drawer>
        <v-content>
          <v-container fluid fill-height>
            <v-layout justify-center class="chatboxnonselect" column>
              <v-layout row wrap>
                <v-flex sm12 md12 lg12 xl12>
                  <v-btn class="btn-color" @click="toChatroom()">
                    <v-icon left class="icon-color">fas fa-chevron-left</v-icon>
                    <span>{{$t('Task.allTask.back')}}</span>
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-layout row wrap justify-center>
                <v-flex sm2 md2 lg2 xl2 class="ml-3">
                  <h2>{{$t('Task.allTask.myProject',{count: listproject.length})}}</h2>
                </v-flex>
                <v-flex sm4 md4 lg4 xl4>
                </v-flex>
                <v-flex sm3 md3 lg3 xl3></v-flex>
                <v-flex sm2 md2 lg2 xl2>
                  <v-btn class="btn-create-task" @click="open_create_project()">
                    <v-icon left class="icon-create-task">fas fa-plus</v-icon>
                    <span>{{$t('Task.allTask.createProject')}}</span>
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-if="listproject.length !== 0">
                <v-flex sm5 md5 lg5 xl5 class="ml-50">
                  <v-text-field
                    v-model="search"
                    solo
                    :label="$t('Task.allTask.placeholderSearchProject')"
                    clearable
                    append-icon="search"
                  ></v-text-field>
                </v-flex>
                <v-flex sm4 md4 lg4 xl4 class="ml-3">
                </v-flex>
              </v-layout>
              <v-flex xs12 sm12 md12 xl12 lg12 v-if="listproject.length != 0">
                <v-card class="card-tabs">
                  <v-container grid-list-lg fluid style="min-height: 0; height: calc(100vh - 270px) !important;" class="scrolling-wrapper">
                    <v-layout row wrap class="mt-3 mr-2 ml-2">
                      <v-flex
                        v-for="(item, index) in FilterListProject"
                        :key="index"
                        xs4
                      >
                        <v-card class="d-flex card-project">
                          <v-layout column>
                            <v-flex xs12 md12 sm12 lg12 xl12 >
                              <v-card-title primary-title>
                                <v-layout row>
                                  <div class="font-size-20 text-overflow-project">{{item.project_name}}</div>
                                  <v-spacer></v-spacer>
                                  <div class="color-grey mt-1">
                                    {{$t('Task.allTask.createDate',{date: formatDate(item.timestamp)})}}
                                  </div>
                                </v-layout>
                              </v-card-title>
                              <v-card-actions>
                                <v-layout class="ml-1 mr-1" wrap column>
                                  <!-- <div class="color-grey" v-if="item.detail != ''" >
                                    <read-more class="mb-0" :more-str="$t('ChatSide.Read.readmore')" :text="item.detail" link="#" :less-str="$t('ChatSide.Read.readless')" :max-chars="100" style="width: 270px !important;"></read-more>
                                  </div> -->
                                  <v-layout row wrap class="mt-2">
                                    <v-chip v-for="i in item.state" text-color="primary" outline label>
                                      {{i.name}} {{i.count_member}}
                                    </v-chip>
                                    <v-spacer></v-spacer>
                                    <v-avatar
                                      size="40px"
                                      class="mr-1"
                                    >
                                      <img :src="item.path_pic" alt="alt" class="" v-if="item.path_pic" class="object-fit-img">
                                      <img src="/static/img/default_profile/man-white.png" alt="" v-else class="border-img object-fit-img">
                                    </v-avatar>
                                  </v-layout>
                                </v-layout>
                              </v-card-actions>
                              <v-divider light class="mt-3"></v-divider>
                              <v-layout row wrap class="mt-2" @click="topage_task(item._id, item.tokenroom)" style="cursor: pointer; margin-bottom: 5px !important;">
                                <span class="pl-3 pr-3">
                                  {{$t('Task.allTask.detailProject')}}
                                </span>
                                <v-icon>fas fa-angle-right</v-icon>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-flex>
              <v-flex xs12 sm12 md12 xl12 lg12 v-else class="flex-center">
                <h4>{{$t('Task.allTask.noProjectList')}}</h4>
              </v-flex>
            </v-layout>
          </v-container>
        </v-content>
      </v-flex>
    </v-layout>
    <CreateProject :dialogCreateProject="dialogCreateProject" @closeCreateProject="closeCreateProject" :projectid="projectid" @createdproject="createdproject"></CreateProject>
  </v-container>
</template>

<script>
import { sync } from 'vuex-pathify'
import { Decode, Momenttime } from '@/services'
import Rightside from '@/components/chat/layout/RightSide'
import CreateProject from '@/components/chat/manage_task/created_project_dialog'
var _ = require('lodash')
export default {
  // props: {
  //   source: String
  // },
  components: {
    Rightside,
    CreateProject
  },
  data () {
    return {
      listproject: [],
      dialogCreateProject: false,
      status_login: '',
      windowWidth: '',
      mini: true,
      dialog: false,
      drawer: true,
      search: '',
      detail: {},
      token: '',
      progress: false,
      projectid: '',
      member: [],
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    })
  },
  created () {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
    this.status_login = decoded['status_login']
    this.get_data_room()
    this.get_project_room()
  },
  computed: {
    ...sync('*'),
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) return 0

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    },
    FilterListProject () {
      if (this.search !== '' && this.search !== null) {
        return this.listproject.filter(post => {
          return post.project_name.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return this.listproject
      }
    }
  },
  watch: {
    windowWidth () {
      if (this.windowWidth <= 960) {
        this.$router.push('/mobile/homepage')
      }
    },
    socketmessage (data) {
      // console.log(data)
    },
    socket_deletetask (data) {
      // console.log(data)
    },
    socket_edittask (data) {
      // console.log(data)
    }
  },
  methods: {
    formatDate (input) {
      var datePart = input.match(/\d+/g),
      year = datePart[0].substring(2), // get only two digits
      month = datePart[1],
      day = datePart[2];

      return day+'/'+month+'/'+year;
    },
    datetime (timestamp) {
      return (this.$i18n.locale == 'th')? Momenttime.momentdatethai(timestamp): Momenttime.momentdateen(timestamp)
    },
    topage_task (projectid, tokenroom) {
      // console.log(projectid)
      this.$router.push('/chat/task/' + projectid + '/' + tokenroom)
    },
    momentday (timestamp) {
      return Momenttime.momentdatethai(timestamp)
    },
    createdproject (value) {
      this.get_project_by_id(value.project_id, value.event)
    },
    closeCreateProject (value) {
      this.dialogCreateProject = value
    },
    open_create_project () {
      this.dialogCreateProject = true
    },
    toChatroom () {
      this.$router.push('/chat/room/' + this.$route.params.roomid)
      // this.$router.go(-1)
    },
    get_data_room () {
      this.detail = {}
      this.progress = true
      this.axios.post(process.env.APImanage + '/getroom', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid
      }).then((response) => {
        if (response.data.status === 'success') {
          this.progress = false
          this.detail = response.data
          var member = []
          member = response.data.data_room
          this.member = _.filter(member, function(o) { return o.statemember == 'active' })
        }
      })
    },
    get_project_room () {
      this.axios.post(process.env.APIpub + '/v1/user/get_project_by_tokenroom', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid
      }).then((response) => {
        // console.log(response.data.data)
        if (response.data.status === 'success') {
          this.listproject = response.data.data
          this.listproject = _.reverse(this.listproject)
        }
      }).catch(error => {
        console.log(error.message)
      })
    },
    get_project_by_id (projectid, events) {
      this.axios.post(process.env.APIpub + '/v1/user/get_project_by_id', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid,
        project_id: projectid
      }).then((responsed) => {
        // console.log(responsed.data.data)
        if (responsed.data.status == 'success') {
          if (events == 'create_project') {
            this.listproject.unshift({
              'project_name': responsed.data.data.project_name,
              'timestamp': responsed.data.data.timestamp,
              'count_task': '0',
              '_id': responsed.data.data._id,
              'detail': responsed.data.data.detail,
              'tokenroom': responsed.data.data.tokenroom,
              'state': responsed.data.data.state,
              'path_pic': responsed.data.data.owner_info.path_pic
            })
            // this.listproject.unshift(responsed.data.data)
          }
        }
      }).catch(error => {
        console.log(error.message)
      })
    }
  }
}
</script>
<style type="text/css" scoped>
.scrolling-wrapper {
  /*display: flex;*/
  overflow-y: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 8px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}
.flex-center{
  justify-content: center;
  align-items: center;
  display: flex;
}
>>>.v-chip .v-chip__content {
  cursor: default !important;
  justify-content: space-between !important;
  padding-left: 4px !important;
  padding-right: 4px !important;
  white-space: nowrap !important;
  z-index: 1 !important;
  height: 17px !important;
}
.text-overflow-project {
  width: 140px !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
.span-detail-project {
  color: #8e8e92 !important;
  margin-left: 20px !important;
}
.card-project {
  border-radius: 10px !important;
  background-color: white !important;
  /* border-color: #dadada !important; */
  border-style: solid !important;
  border-width: thin !important;
  /* height: 140px !important; */
  /* cursor: pointer !important; */
}
.card-project:hover {
  border-radius: 10px !important;
  background-color: rgba(234, 234, 234, 0.23137254901960785) !important;
  border-color: rgba(234, 234, 234, 0.23137254901960785) !important;
  border-style: solid !important;
  border-width: thin !important;
  /* height: 140px !important; */
  /* cursor: pointer !important; */
}
.span-timestamp {
  font-size: 14px !important;
  color: grey !important;
}
>>>.v-list {
    /* min-width: 210px !important; */
    max-width: 100% !important;
}
.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}
.text-transform {
  /* text-transform: uppercase; */
  text-transform: capitalize !important;
}
.btn-plus-user {
  background-color: #efefef !important;
  color: #1d1d1d !important;
  box-shadow: none !important;
}
.font-size18 {
  font-size: 18px !important;
}
.font-title-task {
  font-size: 19px !important;
  font-weight: 500 !important;
}
/* >>>.v-list__tile .theme--light {
  height: 200px !important;
} */
/* >>>.v-navigation-drawer .v-list .v-list__tile {
  height: 200px !important;
  transition: none !important;
  font-weight: 500 !important;
} */
.card-task-pri1 {
  background-color: white !important;
  color: black !important;
  border-style: solid !important;
  border-radius: 10px !important;
  border-width: thin !important;
  /* margin-bottom: 15px; */
  /* border-color: #1b232d; */
  margin-top: 10px !important;
  margin-left: 5px !important;
  margin-right: 5px !important;
  border-left-color: #b3493d !important;
  border-left-width: 12px !important;
  /* border-left-style: solid; */
  height: 100px !important;
  cursor: pointer !important;
}
.card-task-pri2 {
  background-color: white !important;
  color: black !important;
  border-style: solid !important;
  border-radius: 10px !important;
  border-width: thin !important;
  /* margin-bottom: 15px; */
  /* border-color: #1b232d; */
  margin-top: 10px !important;
  margin-left: 5px !important;
  margin-right: 5px !important;
  border-left-color: #fcbe55 !important;
  border-left-width: 12px !important;
  /* border-left-style: solid; */
  height: 100px !important;
  cursor: pointer !important;
}
.card-task-pri3 {
  background-color: white !important;
  color: black !important;
  border-style: solid !important;
  border-radius: 10px !important;
  border-width: thin !important;
  /* margin-bottom: 15px; */
  /* border-color: #1b232d; */
  margin-top: 10px !important;
  margin-left: 5px !important;
  margin-right: 5px !important;
  border-left-color: #a0a1a3 !important;
  border-left-width: 12px !important;
  /* border-left-style: solid; */
  height: 100px !important;
  cursor: pointer !important;
}
.overflow-scroll {
  overflow-y: scroll !important;
}
.object-fit-img {
  object-fit: cover;
  object-position: 50% 0;
}
.border-img {
  border-color: grey !important;
  border-style: solid !important;
  border-width: thin !important;
}
.margin-top-120px {
  margin-top: 120px !important;
}
.text-overflow {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 250px !important;
  text-align: center !important;
}
.text-overflow-groupname {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 180px !important;
  /* text-align: center !important; */
}
.text-overflow-list {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 190px !important;
}
.color-white {
  color: white !important;
}
/* >>>.v-list__tile__content {
  height: 70vh;
  margin-top: 50px;
} */
.height-100vh {
  height: 100vh !important;
}
.height-200px {
  height: 200px !important;
}
.height-300px {
  height: 300px !important;
}
.width-100 {
  width: 100% !important;
}
.color-card-task {
  overflow: scroll !important;
  height: 60vh !important;
  margin-top: 20px !important;
  border-radius: 6px !important;
  background-color: #f1f1f1 !important;
}
.system-bar {
  height: 4px !important;
  background-color: #e0e0e0 !important;
  border-radius: 10px !important;
  /* margin-left: 18px !important; */
}
.font-size-16 {
  font-size: 16px !important;
}
.font-size-20 {
  font-size: 20px !important;
}
.ml-50 {
  margin-left: 50px !important;
}
.span-clear-filter {
   color: #949494 !important;
   font-size: 16px !important;
}
>>>.v-input__slot {
  border-radius: 13px !important;
  box-shadow: none !important;
  background-color: rgba(142, 142, 147, 0.12156862745098039) !important;
}
.btn-filter-task {
  border-radius: 6px !important;
  border: solid 1px #2562af !important;
  color: #2562af !important;
  background-color: white !important;
  box-shadow: none !important;
}
.icon-filter-task {
  color: #2562af !important;
  font-size: 16px !important;
}
.icon-create-task{
  color: white !important;
  font-size: 16px !important;
}
.btn-create-task {
  text-transform: none !important;
  background-color: #2561b0 !important;
  /* border-color: #2561b0 !important; */
  border-style: solid !important;
  border-radius: 6px !important;
  color: white !important;
  box-shadow: none !important;
}
.btn-nav {
  background-color: #d8d8d8 !important;
}
>>>.v-list .v-list--dense .theme--light {
  margin-top: 70px !important;
}
.bg-flex-1 {
  background-color: #1b232d;
}
.container{
  padding: 0px !important;
}
.fixed-content {
  min-height:100%;
  /*position:fixed;*/
  overflow-y:scroll;
  overflow-x:hidden;
}
.content {
  padding: 0px 0px 0px !important;
}
>>>.chatboxnonselect {
  width: 100%;
  min-width: 10vw;
  height: calc(100vh - 64px);
  background-color:white;
  overflow-y: hidden;
}
.btn-color {
  text-transform: none !important;
  background-color: white !important;
  border-color: #2561b0 !important;
  border-style: solid !important;
  border-radius: 6px !important;
  color: #2561b0 !important;
  box-shadow: none !important;
}
.icon-color {
  color: #2561b0 !important;
}
>>> .theme--light.v-card {
    background-color: #fff;
    border-color: none !important;
    color: rgba(0,0,0,.87);
}
</style>



// WEBPACK FOOTER //
// src/components/chat/manage_task/homepage_project.vue